import { defineComponent, watch, onBeforeUnmount, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Banner from '@/components/Banner.vue';
import ContestTable from './components/ContestTable.vue';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { UserExamService } from '@/services/userExam.service';
import { UserService } from '@/services/user.service';
import { ContestPlatformVals, SHOW_BRAND } from '@/utils';
import emptyImage from '@/assets/image/home/empty.png';
import ContestTabs from './components/ContestTabs/index.vue';
export default defineComponent({
  name: 'UserItemList',
  components: {
    Banner: Banner,
    ContestTable: ContestTable,
    ContestTabs: ContestTabs
  },
  setup: function () {
    declareProviders([UserExamService]);
    var userService = useService(UserService);
    var userExamService = useService(UserExamService);
    var route = useRoute();
    var router = useRouter();
    var query = route.query;
    /**
     *  reservePage: 1 保留当前页面并弹出弹框
     */
    var reservePage = query.showLoginModal;
    if (userService.user) {
      userExamService.resetSearch();
    } else if (reservePage) {
      router.replace(SHOW_BRAND ? {
        name: 'Home'
      } : '/activity/list');
    }
    onBeforeUnmount(function () {
      userExamService.clearTimer();
    });
    watch(function () {
      return userService.user;
    }, function (user) {
      if (user && user.userId) {
        userExamService.resetSearch();
      }
    });
    // 监听路由的state变化时 触发对应的列表请求
    watch(function () {
      return userExamService.pageStatus;
    }, function () {
      userExamService.resetSearch();
    }, {
      immediate: false
    });
    var isNocFlag = computed(function () {
      return route.query.platform ? ContestPlatformVals.includes(route.query.platform) : false;
    });
    return {
      userService: userService,
      userExamService: userExamService,
      emptyImage: emptyImage,
      isNocFlag: isNocFlag
    };
  }
});